import { Expose } from 'class-transformer';

/**
 * How Disbursement Works 页试算数据(数据来源：QueryDisbursementWorksPage / BFF 6.11)
 * 字段沿用后端 snake_case，不转驼峰；金额为 string(Currency.format 可直接吃)。
 * 放款比例 / 费率为后端下发的展示值，前端直接拼 "%"，不做换算。
 */
export class DisbursementWorksModel {
  /** 总订单金额(Eligible/Estimated 基数) */
  @Expose()
  total_mortgage_amount!: string;

  /** Standard：Amount Received = principal - service_charge */
  @Expose()
  to_be_received_amount!: string;

  /** Standard：Eligible Order Amount(= standard Repayment) */
  @Expose()
  principal_amount!: string;

  /** Standard：Upfront Fee */
  @Expose()
  service_charge_amount!: string;

  /** Standard 放款比例(展示值) */
  @Expose()
  disburse_percentage!: string;

  /** 服务费率(展示值，如 0.5 → "0.5%") */
  @Expose()
  service_charge_rate!: string;

  /** Loan #1 放款比例(展示值) */
  @Expose()
  cache_disburse_percentage!: string;

  /** Advance Loan #1：Estimated Order Amount */
  @Expose()
  loan1_principal_amount!: string;

  /** Advance Loan #2：Remaining Order Amount */
  @Expose()
  loan2_principal_amount!: string;

  /** Advance：cache Repayment = loan1 + loan2 principal */
  @Expose()
  total_principal_amount!: string;

  /** Advance Loan #1 Upfront Fee */
  @Expose()
  loan1_service_charge_amount!: string;

  /** Advance Loan #2 Upfront Fee */
  @Expose()
  loan2_service_charge_amount!: string;

  /** Advance Loan #1 Received */
  @Expose()
  loan1_to_be_received_amount!: string;

  /** Advance Loan #2 Received */
  @Expose()
  loan2_to_be_received_amount!: string;

  /** Advance：Total Amount Received */
  @Expose()
  total_to_be_received_amount!: string;

  /** 是否免息期(true 展示 FREE) */
  @Expose()
  is_in_free_period!: boolean;

  /** 免息天数 N(与 Homepage 同源的 FreeFeeDays 配置)，BR 用于 "1st N days free" 标签 */
  @Expose()
  free_interest_promotion_days!: number;
}
